var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tradique-layout" }, [
    _c("div", { staticClass: "d-flex w-100 h-100" }, [
      _c("div", { staticClass: "form-container" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c("div", { staticClass: "promotion-container" }, [
        _c("img", { attrs: { src: _vm.tradiqueBanner.banner } })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }